import { reactive } from 'vue'
import { setMode, setColor } from './useTheme'

export const Benutzer = reactive({
  Id: null,
  Name: null,
  EMail: null,
  Angemeldet: false,
  SitzungGeprueft: false
})

let SitzungsPruefung = null

async function AntwortLesen(Antwort) {
  const Daten = await Antwort.json().catch(() => ({}))
  if (!Antwort.ok) {
    const Fehler = new Error(Daten.Fehler || 'Unbekannter Fehler')
    Fehler.Daten = Daten
    throw Fehler
  }
  return Daten
}

function ProfilAufTheme(Daten) {
  if (!Daten.Modus) {
    return
  }
  setMode(Daten.Modus === 'Dunkel' ? 'dark' : 'light')
  // Nur die Akzentfarbe ist noch individuell; alte Default-Werte (#42b883) werden ignoriert,
  // damit Bestandsprofile automatisch das neue Design bekommen
  if (Daten.Akzentfarbe && Daten.Akzentfarbe.toLowerCase() !== '#42b883') {
    setColor('primary', Daten.Akzentfarbe)
  }
}

export async function Registrieren(EMail, Passwort, Captcha) {
  const Antwort = await fetch('/backend/registrieren.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ EMail, Passwort, Captcha })
  })
  // Kein Auto-Login mehr: das Konto ist erst nach der E-Mail-Bestätigung nutzbar
  return AntwortLesen(Antwort)
}

export async function Anmelden(EMail, Passwort, AngemeldetBleiben = false) {
  const Antwort = await fetch('/backend/anmelden.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ EMail, Passwort, AngemeldetBleiben })
  })
  await AntwortLesen(Antwort)
  return AktuellenBenutzerLaden()
}

export async function CaptchaLaden() {
  const Antwort = await fetch('/backend/captchaLaden.php', {
    credentials: 'include',
    cache: 'no-store'
  })
  return AntwortLesen(Antwort)
}

export async function BestaetigungErneutSenden(EMail) {
  const Antwort = await fetch('/backend/bestaetigungErneutSenden.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ EMail })
  })
  return AntwortLesen(Antwort)
}

export async function Abmelden() {
  await fetch('/backend/abmelden.php', { method: 'POST', credentials: 'include' })
  Benutzer.Id = null
  Benutzer.Name = null
  Benutzer.EMail = null
  Benutzer.Angemeldet = false
  // Offline-Caches des Service Workers leeren – keine fremden Daten beim nächsten Benutzer
  if ('caches' in window) {
    caches.delete('topfkucker-daten-v1').catch(() => {})
    caches.delete('topfkucker-bilder-v1').catch(() => {})
  }
}

export async function AktuellenBenutzerLaden() {
  try {
    const Antwort = await fetch('/backend/aktuellerBenutzer.php', { credentials: 'include' })
    if (!Antwort.ok) {
      Benutzer.Angemeldet = false
      return null
    }
    const Daten = await Antwort.json()
    Benutzer.Id = Daten.Id
    Benutzer.Name = Daten.Name
    Benutzer.EMail = Daten.EMail
    Benutzer.Angemeldet = true
    ProfilAufTheme(Daten)
    return Daten
  } finally {
    Benutzer.SitzungGeprueft = true
  }
}

export function SitzungSicherstellen() {
  if (!SitzungsPruefung) {
    SitzungsPruefung = AktuellenBenutzerLaden()
  }
  return SitzungsPruefung
}

export async function ProfilSpeichern(Profil) {
  const Antwort = await fetch('/backend/profilSpeichern.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(Profil)
  })
  return AntwortLesen(Antwort)
}

export async function KontoAktualisieren(Aenderungen) {
  const Antwort = await fetch('/backend/kontoSpeichern.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(Aenderungen)
  })
  const Daten = await AntwortLesen(Antwort)
  if (Aenderungen.Name !== undefined) {
    Benutzer.Name = Aenderungen.Name
  }
  if (Aenderungen.EMail !== undefined) {
    Benutzer.EMail = Aenderungen.EMail
  }
  return Daten
}
